module.exports = __webpack_public_path__ + "static/img/04.a4a1924.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/04.jpg
// module id = 74nk
// module chunks = 0